export default __webpack_public_path__ + "c91615e49891e795524913355baabea5.svg";